import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const dashboardService = {
  // Analytics (counts/totals) — switches by user type
  adminAnalytics: (p: { start_date?: string; end_date?: string; city_id?: number } = {}) => {
    const params: Record<string, unknown> = { locale: 'en' }
    if (p.start_date) params.start_date = p.start_date
    if (p.end_date) params.end_date = p.end_date
    if (p.city_id) params.city_id = p.city_id
    return restClient.get(`${endpoints.analytics.admin}?${q(params)}`).then(r => r.data)
  },
  schoolAnalytics: (p: { start_date?: string; end_date?: string } = {}) => {
    const params: Record<string, unknown> = { locale: 'en' }
    if (p.start_date) params.start_date = p.start_date
    if (p.end_date) params.end_date = p.end_date
    return restClient.get(`${endpoints.analytics.schoolAdmin}?${q(params)}`).then(r => r.data)
  },
  adminRevenue: (p: { year?: number; city_id?: number; start_date?: string; end_date?: string } = {}) => {
    const params: Record<string, unknown> = { locale: 'en', year: p.year ?? new Date().getFullYear() }
    if (p.city_id) params.city_id = p.city_id
    if (p.start_date) params.start_date = p.start_date
    if (p.end_date) params.end_date = p.end_date
    return restClient.get(`${endpoints.analytics.adminRevenue}?${q(params)}`).then(r => r.data)
  },
  schoolRevenue: (p: Record<string, unknown> = {}) => {
    const params: Record<string, unknown> = { locale: 'en', year: new Date().getFullYear(), ...p }
    return restClient.get(`${endpoints.analytics.schoolAdminRevenue}?${q(params)}`).then(r => r.data)
  },
  studentInsights: (p: { start_date?: string; end_date?: string; city_id?: number } = {}) => {
    const params: Record<string, unknown> = { locale: 'en', ...p }
    return restClient.get(`${endpoints.analytics.studentInsights}?${q(params)}`).then(r => r.data)
  },
  trainerInsights: (p: { start_date?: string; end_date?: string; city_id?: number } = {}) => {
    const params: Record<string, unknown> = { locale: 'en', ...p }
    return restClient.get(`${endpoints.analytics.trainerInsights}?${q(params)}`).then(r => r.data)
  },
  pendingVerifications: (p: { page?: number; limit?: number; sort_by?: string; is_verified?: number; isSchoolAdmin?: boolean } = {}) => {
    const params = new URLSearchParams({
      page: String(p.page ?? 1),
      limit: String(p.limit ?? 10),
      sort_by: p.sort_by ?? 'desc',
      is_verified: String(p.is_verified ?? 0),
    })
    const endpoint = p.isSchoolAdmin
      ? endpoints.pendingRequest.schoolAdminList
      : endpoints.pendingRequest.trainerPendingRequest
    return restClient.get(`${endpoint}?${params}`).then(r => r.data)
  },
  // ── Heat Map data (admin) ─────────────────────────────────────────────────
  // Mirrors the old dashboard: trainers from the "nearest trainers" endpoint and
  // students from the "students under radius" endpoint, both around a center point.
  // radius: 1000 (hardcoded) for both, per request. The API paginates like other
  // list endpoints (default 10/page — response shows count_per_page: 10, total: 389),
  // so `limit`/`page`/`count_per_page` are all sent high to pull every match for the map.
  nearestTrainers: (p: { latitude: number; longitude: number } ) =>
    restClient.get(`${endpoints.users.getTrainerNearestAddress}?${q({
      latitude: p.latitude, longitude: p.longitude, radius: 1000,
      limit: 1000, count_per_page: 1000, page: 1, locale: 'en',
    })}`).then(r => r.data),
  studentsUnderRadius: (p: { latitude: number; longitude: number } ) =>
    restClient.get(`${endpoints.users.getStudentsUnderRadius}?${q({
      latitude: p.latitude, longitude: p.longitude, radius: 1000,
      limit: 1000, count_per_page: 1000, page: 1, locale: 'en',
    })}`).then(r => r.data),
}
